import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ModalFooter,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { fetchBirthdayReport, fetchCategories, fetchDepartments, fetchDesignation, fetchDesignations, resetEmployeeReport, sendBirthdayWishes } from "store/actions";
import * as Yup from "yup";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const EmployeeReportBirthDay = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    designations,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.EmployeeReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    designations: state.DesignationMaster?.designations ?? [],

    loading: state.EmployeeReportReducer?.loading,
    error: state.EmployeeReportReducer?.error,
    success: state.EmployeeReportReducer?.success,
  }));

  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

  useEffect(() => {
    dispatch(resetEmployeeReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      fromDate: "",
      toDate: "",
      type: "Birth Day",
    },
    validationSchema: Yup.object({
      fromDate: Yup.string()
        .required("From Date is required"),
      toDate: Yup.string()
        .required("To Date is required")
        .test(
          "date-check",
          "To Date must be greater than or equal to From Date",
          function (value) {
            const { fromDate } = this.parent;
            if (!fromDate || !value) return true;
            return new Date(value) >= new Date(fromDate);
          }
        ),
    }),
    onSubmit: (values) => {
      const formData = new FormData();

      formData.append("emp_cat", values.category || 0);
      formData.append("emp_dep", values.department || 0);
      formData.append("emp_design", values.designation || 0);
      formData.append("unit_id", authDetails?.unit_id);

      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);

      const typeValue = values.type === "Birth Day" ? 1 : 2;
      formData.append("Opt", typeValue);

      dispatch(fetchBirthdayReport(formData));
    },
  });

  // const columns = [
  //    {
  //     Header: "Send Wish",
  //     className: "text-center",
  //     Cell: ({ row }) => (
  //       <Button 
  //         size="sm" 
  //         color="light" 
  //         onClick={() => openWishesModal(row.index)}
  //       >
  //         <i className="fas fa-envelope"></i>
  //       </Button>
  //     ),
  //   },
  //   { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
  //   { Header: "Code", accessor: "emp_no" },
  //   { Header: "Name", accessor: "name" },
  //   { Header: "Category", accessor: "category" },
  //   { Header: "Department", accessor: "department" },
  //   { Header: "Designation", accessor: "designation" },    
  //   { Header: "DOB", accessor: "bday_dt" },
  //   { Header: "Years", accessor: "birth_years" },
   
  // ];

  const getColumnsByType = (type) => {
    const baseColumns = [
      {
        Header: "Send Wish",
        className: "text-center",
        Cell: ({ row }) => (
          <Button 
            size="sm"
            color="light"
            onClick={() => openWishesModal(row.index)}
          >
            <i className="fas fa-envelope"></i>
          </Button>
        ),
      },
      { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "text-center" },
      { Header: "Code", accessor: "emp_no" },
      { Header: "Name", accessor: "name" },
      { Header: "Category", accessor: "category" },
      { Header: "Department", accessor: "department" },
      { Header: "Designation", accessor: "designation" },
    ];

    const birthdayColumns = [
      { Header: "DOB", accessor: "bday_dt" },
      { Header: "Years", accessor: "birth_years" },
    ];

    const weddingColumns = [
      { Header: "Wedding Date", accessor: "wedding_dt" },
      { Header: "Years", accessor: "wedding_Years" },
    ];

    return [
      ...baseColumns,
      ...(type === "Wedding Day" ? weddingColumns : birthdayColumns),
    ];
  };

  const columns = useMemo(
    () => getColumnsByType(formik.values.type),
    [formik.values.type, employeeReport]
  );


  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetEmployeeReport()); 
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEmployeeIndex, setSelectedEmployeeIndex] = useState(null);
  const [wishMessage, setWishMessage] = useState("");

  const openWishesModal = (index) => {
    setSelectedEmployeeIndex(index);
    setWishMessage(""); // Reset previous text
    setModalOpen(true);
  };

  const closeWishesModal = () => {
    setModalOpen(false);
    setSelectedEmployeeIndex(null);
    setWishMessage("");
  };

  const handleSendWishes = () => {
    const emp = employeeReport[selectedEmployeeIndex];
    const formData = new FormData();
    formData.append("emp_id", emp.emp_id);
    formData.append("remarks", wishMessage || `Happy Birthday ${emp.emp_name}! 🎂`);
    formData.append("create_by", authDetails?.user_id);
    dispatch(sendBirthdayWishes(formData));
    closeWishesModal();
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Employee" breadcrumbItem="Birthday Report" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                  <Label>Category</Label>
                  <CustomSelect
                    id="category"
                    name="category"
                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                    value={
                      categories
                        .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                        .find(cat => cat.value === formik.values.category) || null
                    }
                    onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                  />
                </Col>                

                <Col md={3}>
                  <Label>Department</Label>
                  <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                      value={
                        departments
                          .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                          .find(dept => dept.value === formik.values.department) || null
                      }
                      onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                    />
                </Col>

                <Col md={3}>
                  <Label>Designation</Label>
                  <CustomSelect
                      id="designation"
                      name="designation"
                      options={designations.map(des => ({ value: des.desig_id, label: des.designation }))}
                      value={
                        designations
                          .map(des => ({ value: des.desig_id, label: des.designation }))
                          .find(des => des.value === formik.values.designation) || null
                      }
                      onChange={(val) => formik.setFieldValue("designation", val ? val.value : "")}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${
                        formik.touched.designation && formik.errors.designation ? "is-invalid" : ""
                      }`}
                    />
                </Col>

                 <Col md={3}>
                    <Label className="mb-0"></Label>
                    <div className="d-flex align-items-center gap-4 mt-2">
                      
                      <Label className="mb-0 d-flex align-items-center gap-2">
                        <Input
                          type="radio"
                          name="type"
                          value="Birth Day"
                          checked={formik.values.type === "Birth Day"}
                         onChange={(e) => {
                            formik.handleChange(e);
                            dispatch(resetEmployeeReport());
                          }}
                        />
                        Birth Day
                      </Label>

                      <Label className="mb-0 d-flex align-items-center gap-2">
                        <Input
                          type="radio"
                          name="type"
                          value="Wedding Day"
                          checked={formik.values.type === "Wedding Day"}
                          // onChange={formik.handleChange}
                          onChange={(e) => {
                            formik.handleChange(e);
                            dispatch(resetEmployeeReport());
                          }}
                        />
                        Wedding Day
                      </Label>

                    </div>
                  </Col>

                <Col md={3}>
                  <Label>From Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate && (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  )}
                </Col>

                <Col md={3}>
                  <Label>To Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.toDate && formik.errors.toDate ? "is-invalid" : ""}`}
                  />
                  {formik.touched.toDate && formik.errors.toDate && (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  )}
                </Col>     

                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 mt-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {/* <Button type="button" className="btn button-export mt-2">
                    <i className="fas fa-file-export me-1" /> Export
                  </Button> */}
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Birthday Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Birthday Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>

        <Modal isOpen={modalOpen} toggle={closeWishesModal} centered>
          <ModalHeader toggle={closeWishesModal} className="fw-bold text-primary">
            🎉 Send Wishes
          </ModalHeader>
          <ModalBody>
            {employeeReport[selectedEmployeeIndex] && (
              <>
                <p>
                  {employeeReport[selectedEmployeeIndex].emp_no} - {employeeReport[selectedEmployeeIndex].name}
                </p>
                <p className="text-muted mb-3">
                  {employeeReport[selectedEmployeeIndex].designation}
                </p>

                <Label for="wishMessage" className="fw-semibold">Your Message</Label>
                <Input
                  id="wishMessage"
                  type="textarea"
                  rows="4"
                  placeholder="Write your warm wishes..."
                  value={wishMessage}
                  onChange={(e) => setWishMessage(e.target.value)}
                />
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button 
              color="success" 
              disabled={!wishMessage.trim()}
              onClick={handleSendWishes}>
              Send
            </Button>
            <Button color="secondary" onClick={closeWishesModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default EmployeeReportBirthDay;
